/* eslint-disable no-console */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
/* eslint-disable react/no-danger */
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Rnd } from 'react-rnd';
import { Box, Divider, List, ListItem, ListItemText, Grid, Button, Checkbox, Tooltip, Modal, Stack } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import { get } from 'lodash';
import { stripperDict } from '../../states/reducers/myFiles';
import { closeIconBlack } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import './stripper.scss';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { getBorderColor } from '../../shared/utils';

const checkboxprop = { inputProps: { 'aria-label': 'Checkbox demo' } };
const StripperInput = (props) => {
  const dispacth = useDispatch();
  const outlinedBasicCo2 = useRef();
  const outlinedBasicH2s = useRef();
  const outlinedBasicNh3 = useRef();
  const { visibleStripper, handleCloseStripper, stripperDetails, disabledStripperAndExplorerTab, translateObject, setokbuttonFormAutoSave } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [activeTab] = useState('1');
  const [defaltSelectedValue, setDefaltSelectedValue] = useState({
    'stripper_flag': false,
    'target_co2': '5.00',
    'target_h2s': '0.00',
    'target_nh3': '0.00'
  });
  const [, setDefautId] = useState('');
  const [defaultCheck, setDefaultCheck] = useState(false);
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);
  const [target_co2, settarget_co2] = useState(0.00);
  const [target_h2s, settarget_h2s] = useState(0.00);
  const [target_nh3, settarget_nh3] = useState(0.00);

  const handleClose_Stripper = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    // updateGlobalValue({...globalValue, 'stripper' : false});
    handleCloseStripper();
  };

  const handleCloseSplitModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleClose_Stripper(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseStripper();
    };
  };

  useEffect(() => {
    const stripper_id = stripperDetails.id;
    const stripperData = get(JSON.parse(localStorage.getItem('stripper-dict')), 'st', {});
    if (stripperData && stripperData[stripper_id]) {
      setDefaltSelectedValue(stripperData[stripper_id]);
      setDefaultCheck(stripperData[stripper_id].stripper_flag);
      settarget_co2(stripperData[stripper_id].target_co2);
      settarget_h2s(stripperData[stripper_id].target_h2s);
      settarget_nh3(stripperData[stripper_id].target_nh3);
    }
    setDefautId(stripper_id);
  }, []);
  const chakedUncheckedInput = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    // updateGlobalValue({...globalValue, 'stripper' : true});
    setDefaultCheck(e.target.checked);
    const co2 = outlinedBasicCo2.current.value;
    const h2s = outlinedBasicH2s.current.value;
    const nh3 = outlinedBasicNh3.current.value;
    setDefaltSelectedValue({
      'stripper_flag': e.target.checked,
      'target_co2': co2,
      'target_h2s': h2s,
      'target_nh3': nh3
    });
    disabledStripperAndExplorerTab();
  };
  const setDataOnLocalStroage = () => {
    if (!defaltSelectedValue.stripper_flag) {
      defaltSelectedValue.target_co2 = '5.00';
      defaltSelectedValue.target_h2s = '0.00';
      defaltSelectedValue.target_nh3 = '0.00';
    } else {
      defaltSelectedValue.target_co2 = Number(parseFloat(defaltSelectedValue.target_co2).toFixed(2));
      defaltSelectedValue.target_h2s = Number(parseFloat(defaltSelectedValue.target_h2s).toFixed(2));
      defaltSelectedValue.target_nh3 = Number(parseFloat(defaltSelectedValue.target_nh3).toFixed(2));
    }
    dispacth(stripperDict({
      record: defaltSelectedValue,
      type: 'st',
      id: stripperDetails.id,
      item: 'stripper-dict'
    }));
    saveFormDataInLocalStorage({
      record: defaltSelectedValue,
      type: 'st',
      id: stripperDetails.id,
      item: 'stripper-dict'
    });
    // localStorage.setItem(`${defautId}`, JSON.stringify(defaltSelectedValue));
    getBorderColor(stripperDetails.id);
    setokbuttonFormAutoSave(true);
    handleCloseStripper();
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
  };
  const changeDefaultValue = () => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    // updateGlobalValue({...globalValue, 'stripper' : true});
    const co2 = outlinedBasicCo2.current.value;
    const h2s = outlinedBasicH2s.current.value;
    const nh3 = outlinedBasicNh3.current.value;
    setDefaltSelectedValue({
      'stripper_flag': defaultCheck,
      'target_co2': co2,
      'target_h2s': h2s,
      'target_nh3': nh3
    });
    disabledStripperAndExplorerTab();
  };
  const changetarget_h2s = (event) => {
    settarget_h2s(event.target.value);
  };
  const changetarget_co2 = (event) => {
    settarget_co2(event.target.value);
  };
  const changetarget_nh3 = (event) => {
    settarget_nh3(event.target.value);
  };
  const onBlurText = () => {
    const co2 = parseFloat(outlinedBasicCo2.current.value);
    const h2s = parseFloat(outlinedBasicH2s.current.value);
    const nh3 = parseFloat(outlinedBasicNh3.current.value);
    setDefaltSelectedValue({
      'stripper_flag': defaultCheck,
      'target_co2': co2.toFixed(2),
      'target_h2s': h2s.toFixed(2),
      'target_nh3': nh3.toFixed(2)
    });
  };
  const numberInput = (e) => {
    let val = e.target.value;
    const re = /^([0-9]+[\.]?[0-9]?[0-9]?|[0-9]+)$/g;
    const re1 = /^([0-9]+[\.]?[0-9]?[0-9]?|[0-9]+)/g;
    if (re.test(val)) {

    } else {
      val = re1.exec(val);
      if (val) {
        e.target.value = val[0];
      } else {
        e.target.value = '';
      }
    }
  };
  const getFeedName = () => {
    let splitName = '';
    const local = localStorage.getItem(stripperDetails.id);
    if (local) {
      splitName = ` - ${local}`;
    } else {
      splitName = ` - Splitter ${Number(get(stripperDetails, 'id', '').split('_')[1]) + 1}`;
    }
    return splitName;
  };
  return (
    <Modal
      hideBackdrop
      open={visibleStripper}
      onClose={handleCloseSplitModal}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="splitter-modal"
    >
      <Box>
        <Rnd
          default={{
            x: ((window.innerWidth / 2) - ((40 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((45 * (window.innerHeight / 100)) / 2)),
            width: '40%',
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='25%'
          cancel='.stripper-header-text, .normal-font, .diameter, .cf-input-props, #cbox, .MuiButton-contained'
          className='stripper-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='stripper-grid-container'>
            <Grid item xs={12} className='stripper-header-grid'>
              <div className='stripper-header-text ft rufusBld no_drag S_heading'>{`Stripper ${getFeedName()}`}</div>
              <div className='stripper-close-icon no_drag'>
                <Tooltip title="Close">
                  <img
                    src={closeIconBlack}
                    alt="close"
                    onClick={handleCloseSplitModal}
                    style={{ display: 'block' }}
                    className="pointer"
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='stripper-body-container sansW4SeLig'>
              <Box sx={{ width: '100%', typography: 'body1' }} className='mixer-box-container'>
                <TabContext value={activeTab}>
                  {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className='tab-context'>
                    <TabList aria-label="lab API tabs example">
                      <Tab onClick={() => setActiveTab('1')} label="Feed" value="1" />
                      <Tab onClick={()=>setActiveTab('2')} label="Product" value="2" />
                    </TabList>
                  </Box> */}
                  <TabPanel value="1">
                    <List component="nav" aria-label="mailbox folders" className='outlet-streams no_drag'>
                      <ListItem className='list-item' sx={{ mt: 1, mb: 1 }}>
                        <ListItemText className='col-2'>
                          <div className="normal-font f-left S_Bold">{translateObject('Activate')}</div>
                          <div className='span-2 content-merge'>
                            <Checkbox
                              id="cbox"
                              className={defaultCheck ? 'check-box' : ''}
                              checked={defaultCheck}
                              onChange={chakedUncheckedInput} {...checkboxprop}
                            />
                          </div>
                        </ListItemText>
                      </ListItem>
                      <ListItem className='list-item no_drag' sx={{ mt: 1, mb: 1 }}>
                        <ListItemText className='col-2'>
                          <Grid container item xs={12} spacing={1.75} style={{ display: 'flex', alignItems: 'center' }}>
                            {/* <Grid item xs={6} sm={12} md={12} lg={12} xl={12}> */}
                            <Grid item xs={6} md={6} sm={12}>
                              <div className="normal-font f-left S_Bold" dangerouslySetInnerHTML={{ __html: translateObject('Outlet CO2 concentration') }} />
                            </Grid>
                            <Grid item xs={6} md={6} sm={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                              <input
                                ref={outlinedBasicCo2}
                                id="outlined-basic-co2"
                                variant="outlined"
                                className="Form_Input_design cf-input-props"
                                type="number"
                                name="nh3"
                                onBlur={onBlurText}
                                onChange={!defaultCheck ? changeDefaultValue : changetarget_co2}
                                onFocus={e => e.target.select()}
                                disabled={!defaultCheck}
                                value={!defaultCheck ? defaltSelectedValue.target_co2 : target_co2}
                                onKeyUp={numberInput}
                                style={{ width: '100%', maxWidth: 145 }}
                              />
                              <span className="Form_Input_design_Units diameter">mg/l</span>
                            </Grid>
                          </Grid>
                        </ListItemText>
                      </ListItem>
                      <ListItem className='list-item no_drag' sx={{ mt: 1, mb: 1 }}>
                        <ListItemText className='col-2'>
                          <Grid container item xs={12} spacing={1.75} style={{ display: 'flex', alignItems: 'center' }}>
                            {/* <Grid item xs={6} sm={7} md={8} lg={7} xl={5}> */}
                            <Grid item xs={6} md={6} sm={12}>
                              <div className="normal-font f-left S_Bold" dangerouslySetInnerHTML={{ __html: translateObject('Outlet H2S concentration') }} />
                            </Grid>
                            <Grid item xs={6} md={6} sm={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                              <input
                                ref={outlinedBasicH2s}
                                id="outlined-basic-h2s"
                                variant="outlined"
                                className="Form_Input_design cf-input-props"
                                type="number"
                                name="nh3"
                                onBlur={onBlurText}
                                onChange={!defaultCheck ? changeDefaultValue : changetarget_h2s}
                                onFocus={e => e.target.select()}
                                disabled={!defaultCheck}
                                value={!defaultCheck ? defaltSelectedValue.target_h2s : target_h2s}
                                onKeyUp={numberInput}
                                style={{ width: '100%', maxWidth: 145 }}
                              />
                              <span className="Form_Input_design_Units diameter">mg/l</span>
                            </Grid>
                          </Grid>
                        </ListItemText>
                      </ListItem>
                      <ListItem className='list-item no_drag' sx={{ mt: 1, mb: 1 }}>
                        <ListItemText className='col-2'>
                          <Grid container item xs={12} spacing={1}>
                            {/* <Grid item xs={6} sm={7} md={8} lg={7} xl={5}> */}
                            <Grid item xs={6} md={6} sm={12}>
                              <div className="normal-font f-left S_Bold" dangerouslySetInnerHTML={{ __html: translateObject('Outlet NH3 concentration') }} />
                            </Grid>
                            <Grid item xs={6} md={6} sm={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                              <input
                                ref={outlinedBasicNh3}
                                id="outlined-basic-nh3"
                                variant="outlined"
                                className="Form_Input_design cf-input-props"
                                type="number"
                                name="nh3"
                                onBlur={onBlurText}
                                onChange={!defaultCheck ? changeDefaultValue : changetarget_nh3}
                                onFocus={e => e.target.select()}
                                disabled={!defaultCheck}
                                value={!defaultCheck ? defaltSelectedValue.target_nh3 : target_nh3}
                                onKeyUp={numberInput}
                                style={{ width: '100%', maxWidth: 145 }}
                              />
                              <span className="Form_Input_design_Units diameter">mg/l</span>
                            </Grid>
                          </Grid>
                        </ListItemText>
                      </ListItem>
                    </List>
                    <Divider className="divided" style={{ borderColor: '#D5D3E3' }} />
                    <Stack spacing={2} direction="row" sx={{ 'm': 2, 'justifyContent': 'center', flexWrap: 'wrap' }}>
                      <Button className="btn-auto-width stripper-btn sansW4SeLig M_Bold Secondary-Default_button" variant="contained" onClick={handleCloseSplitModal}
                      >{translateObject('Cancel')}</Button>
                      <Button className="btn-auto-width stripper-btn btn sansW4SeLig
                      M_Bold Primary_Default_Button" variant="contained" onClick={setDataOnLocalStroage}
                      >{translateObject('OK')}</Button>
                    </Stack>
                  </TabPanel>
                </TabContext>
              </Box>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default StripperInput;
